(function(window, document) {
  var isSidenavOpen = false;

  var sidenav = document.getElementById('sidenav');
  var main = document.getElementById('main');
  var appHeader = document.getElementById('app-header');
  var banner = document.getElementById('banner');
  var body = document.getElementsByTagName('body')[0];

  var hamburger = appHeader.getElementsByClassName('hamburger')[0].getElementsByTagName('img')[0];
  var downloads = appHeader.getElementsByClassName('download');
  var bannerHeight = banner.getBoundingClientRect().height;

  var addClass = function(element, className) {
    var classNames = element.className.split(' ');
    var pos = classNames.indexOf(className);

    if (pos === -1) {
      element.className = classNames.concat([className]).join(' ');
    }
  };

  var removeClass = function(element, className) {
    var classNames = element.className.split(' ');
    var pos = classNames.indexOf(className);

    if (pos !== -1) {
      classNames.splice(pos, 1);
      element.className = classNames.join(' ');
    }
  };

  var request = function(options, callback) {
    var request = new XMLHttpRequest();
    request.open(options.method, options.url);

    callback = callback || {};
    var onSuccess = callback.onSuccess || function() {};
    var onError = callback.onError || function() {};

    if ('onload' in request && 'onerror' in request) {
      request.onload = function() {
        onSuccess(request);
      };

      request.onerror = function() {
        onError(request);
      };
    } else {
      request.onreadystatechange = function() {
        if (request.readyState === XMLHttpRequest.DONE) {
          if (request.status === 200) {
            onSuccess(request);
          } else {
            onError(request);
          }
        }
      };
    }

    if (options.params) {
      request.send(JSON.stringify(options.params));
    } else {
      request.send();
    }
  };

  var getCookie = function(cookieName) {
    var cookieString = RegExp(cookieName + '[^;]+').exec(document.cookie);
    return decodeURIComponent(cookieString ? cookieString.toString().replace(/^[^=]+./, '') : '');
  };

  window.openSidenav = function() {
    if (isSidenavOpen) {
      return;
    }

    sidenav.style.display = 'block';
    sidenav.style.left = (window.innerWidth - 250) + 'px';
    main.style.opacity = 0.05;
    appHeader.style.opacity = 0.05;
    body.style.overflowY = 'hidden';
    isSidenavOpen = true;
  };

  window.closeSidenav = function() {
    if (!isSidenavOpen) {
      return;
    }

    sidenav.style.left = '100%';
    main.style.opacity = 1;
    appHeader.style.opacity = 1;
    body.style.overflowY = 'auto';
    setTimeout(function() {
      if (!isSidenavOpen) {
        sidenav.style.display = 'none';
      }
    }, 500);
    isSidenavOpen = false;
  };

  var isExpanded = function(element) {
    return element.className.split(' ').indexOf('down') !== -1;
  };

  var expand = function(element) {
    var list = element.parentNode.parentNode.getElementsByClassName('list')[0];
    var items = list.getElementsByClassName('item');

    var height = 0;
    for (var i = 0; i < items.length; ++i) {
      height += items[i].offsetHeight;

      var style = window.getComputedStyle ?
        window.getComputedStyle(items[i], null) :
        items[i].currentStyle;

      height += parseInt(style.marginTop, 10) || 0;
      height += parseInt(style.marginBottom, 10) || 0;
    }

    addClass(element, 'down');
    element.parentNode.getElementsByClassName('press-to-open')[0].style.opacity = 0;
    list.style.height = height + 'px';
  };

  var collapse = function(element) {
    var list = element.parentNode.parentNode.getElementsByClassName('list')[0];

    removeClass(element, 'down');
    element.parentNode.getElementsByClassName('press-to-open')[0].style.opacity = 1;
    list.style.height = 0;
  };

  window.toggleCollapse = function(row) {
    var element = row.getElementsByTagName('img')[0];
    if (isExpanded(element)) {
      collapse(element);
    } else {
      expand(element);
    }
  };

  window.onCountryChange = function(select) {
    try {
      var selectedCountry = JSON.parse(select.value);

      var parent = select.parentNode;
      parent.getElementsByTagName('img')[0].setAttribute('src', '/images/flags/' + selectedCountry.countryCode.toLowerCase() + '.png');
      parent.getElementsByTagName('span')[0].innerHTML = selectedCountry.callingCode;
    } catch (ex) {}
  };

  window.onPhoneChange = function(input) {
    var container = input.parentNode.parentNode;

    removeClass(container, 'invalid');
  };

  var showDemoSuccess = function(phone, country) {
    var inputs = document.getElementsByClassName('phone-input');
    var inputsSuccess = document.getElementsByClassName('phone-input-success');

    for (var i = 0; i < inputs.length; ++i) {
      inputs[i].getElementsByClassName('loader')[0].style.display = 'none';
      inputs[i].parentNode.style.height = '154px';
      inputs[i].style.opacity = 0;
      inputsSuccess[i].style.opacity = 1;
    }
  };

  window.onPhoneSubmit = function(button) {
    var container = button.parentNode;
    var input = container.getElementsByClassName('input')[0].getElementsByTagName('input')[0];
    var select = container.getElementsByClassName('country-select')[0].getElementsByTagName('select')[0];
    var loader = container.getElementsByClassName('loader')[0];

    var phone = input.value ? input.value.trim() : '';
    var countryValue = {
      countryCode: 'IN',
      name: 'India',
      callingCode: '+91'
    };
    try {
      if (select.value) {
        countryValue = JSON.parse(select.value);
      }
    } catch (ex) {}

    var showError = function() {
      input.readOnly = false;
      button.style.display = 'inherit';
      loader.style.display = 'none';
      addClass(container, 'invalid');
    };

    if (!phone) {
      showError();
      return;
    }

    input.readOnly = true;
    select.disabled = true;
    button.style.display = 'none';
    loader.style.display = 'inherit';

    request({
      method: 'POST',
      url: 'https://1024r140gd.execute-api.us-west-2.amazonaws.com/prod/validate-phone-number',
      params: {
        e164Number: countryValue.callingCode + phone
      }
    }, {
      onSuccess: function(req) {
        try {
          var response = JSON.parse(req.response);
          if (!response.validated) {
            throw new Error('Invalid Phone number');
          }

          request({
            method: 'POST',
            url: 'https://sx-app-a04c1.firebaseio.com/request-demo.json',
            params: {
              callingCode: countryValue.callingCode,
              phone: phone,
              visitorId: getCookie('_visitor_id'),
              timestamp: Date.now()
            }
          }, {
            onSuccess: function() {
              showDemoSuccess(phone, countryValue);
            },
            onError: function() {
              showError();
            }
          });
        } catch (ex) {
          showError();
        }
      },
      onError: function() {
        showError();
      }
    });
  };

  var startSessionTimer = function() {
    var timer = document.getElementsByClassName('live-session')[0].getElementsByClassName('timer')[0];

    var time = 0;
    setInterval(function() {
      time += 1;
      if (time === 600) {
        time = 1;
      }

      var minutes = parseInt(time / 60, 10).toString();
      var seconds = parseInt(time % 60, 10).toString();

      minutes = minutes.length === 1 ? '0' + minutes : minutes;
      seconds = seconds.length === 1 ? '0' + seconds : seconds;

      timer.innerHTML = minutes + ':' + seconds;
    }, 1000);
  };

  var getCountries = function() {
    var inputs = document.getElementsByClassName('phone-input');
    for (var i = 0; i < inputs.length; ++i) {
      inputs[i].getElementsByClassName('country-select')[0].getElementsByTagName('select')[0].disabled = true;
    }

    request({
      method: 'GET',
      url: '/countries'
    }, {
      onSuccess: function(req) {
        try {
          var response = JSON.parse(req.response);

          var documentFragment = document.createDocumentFragment();
          response.forEach(function(country) {
            var optionElement = document.createElement('option');
            optionElement.innerHTML = country.name + '(' + country.callingCode + ')';
            optionElement.value = JSON.stringify(country);
            optionElement.selected = country.countryCode === 'IN';

            documentFragment.appendChild(optionElement);
          });


          for (var i = 0; i < inputs.length; ++i) {
            inputs[i].getElementsByClassName('country-select')[0].getElementsByTagName('select')[0].append(documentFragment.cloneNode(true));
            inputs[i].getElementsByClassName('country-select')[0].getElementsByTagName('select')[0].value = '{"countryCode":"IN","name":"India","callingCode":"+91"}';
            inputs[i].getElementsByClassName('country-select')[0].getElementsByTagName('select')[0].disabled = false;
          }
        } catch (ex) {}
      }
    })
  };

  window.onscroll = function() {
    var scrollTop = (
      (document.scrollingElement || {}).scrollTop ||
      (document.documentElement || {}).scrollTop ||
      document.body.scrollTop ||
      window.scrollY
    );

    if (scrollTop >= bannerHeight) {
      if (hamburger.src.indexOf('hamburger-white') !== -1) {
        hamburger.src = hamburger.src.replace('hamburger-white', 'hamburger');
      }
      addClass(appHeader, 'fixed');
      for (var i = 0; i < downloads.length; ++i) {
        addClass(downloads[i], 'black');
      }
    } else {
      if (hamburger.src.indexOf('hamburger-white') === -1) {
        hamburger.src = hamburger.src.replace('hamburger', 'hamburger-white');
      }
      removeClass(appHeader, 'fixed');
      for (var i = 0; i < downloads.length; ++i) {
        removeClass(downloads[i], 'black');
      }
    }
  };

  (function() {
    expand(document
      .getElementById('features')
      .getElementsByClassName('content')[0]
      .getElementsByClassName('item')[0]
      .getElementsByClassName('title')[0]
      .getElementsByTagName('img')[0]);

    startSessionTimer();
    getCountries();
  })();
})(window, document);

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
